import React, { useState, useEffect } from 'react';
import MediaViewer from '../MediaViewer';
import { Avatar, Link } from '@vkontakte/vkui';
import { Icon24ExternalLinkOutline, Icon28PlayCircleFillGray } from '@vkontakte/icons';
import '../style/drive.css';

const TestGPT = ({ gptLink, gptMedia, gptText, selectedGroup, avatarSrc, activePanel, setActivePanel }) => {
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [initialIndex, setInitialIndex] = useState(0);

    const tg = window.Telegram.WebApp;

    const openViewer = (index) => {
        setInitialIndex(index);
        setIsViewerOpen(true);
    };

    const formattedMedia = gptMedia.map(item => ({
        type: item.includes('.mp4') ? 'video' : 'image',
        src: item
    }));

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('style');
        };

        if (activePanel === 'testgpt') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);


    return (
        <div className="wrapperUI">
            <div className="post-page">
                <div className="post-article">
                    <a className="article-text">Источник:</a>
                    <Link href={gptLink} target="_blank">{gptLink.slice(0, 30)}...<Icon24ExternalLinkOutline width={16} height={16} /></Link>
                </div>
                <div className="post-container">
                    <div className="post-left">
                        <div className="left-top">
                            <Avatar className="premodeAvatar" size={40} initials={selectedGroup?.name.slice(0, 2)}
                                src={avatarSrc} />
                        </div>
                    </div>
                    <div className="post-right">
                        <i className="post-tail">
                            <svg className="tail-icon" width="9px" height="20px" viewBox="0 0 9 20">
                                <g fill="none">
                                    <path className="background" fill="#ffffff"
                                        d="M8,1 L9,1 L9,20 L8,20 L8,18 C7.807,15.161 7.124,12.233 5.950,9.218 C5.046,6.893 3.504,4.733 1.325,2.738 L1.325,2.738 C0.917,2.365 0.89,1.732 1.263,1.325 C1.452,1.118 1.72,1 2,1 L8,1 Z"></path>
                                    <path className="border_1x" fill="#d7e3ec"
                                        d="M9,1 L2,1 C1.72,1 1.452,1.118 1.263,1.325 C0.89,1.732 0.917,2.365 1.325,2.738 C3.504,4.733 5.046,6.893 5.95,9.218 C7.124,12.233 7.807,15.161 8,18 L8,20 L9,20 L9,1 Z M2,0 L9,0 L9,20 L7,20 L7,20 L7.002,18.068 C6.816,15.333 6.156,12.504 5.018,9.58 C4.172,7.406 2.72,5.371 0.649,3.475 C-0.165,2.729 -0.221,1.464 0.525,0.649 C0.904,0.236 1.439,0 2,0 Z"></path>
                                    <path className="border_2x"
                                        d="M9,1 L2,1 C1.72,1 1.452,1.118 1.263,1.325 C0.89,1.732 0.917,2.365 1.325,2.738 C3.504,4.733 5.046,6.893 5.95,9.218 C7.124,12.233 7.807,15.161 8,18 L8,20 L9,20 L9,1 Z M2,0.5 L9,0.5 L9,20 L7.5,20 L7.5,20 L7.501,18.034 C7.312,15.247 6.64,12.369 5.484,9.399 C4.609,7.15 3.112,5.052 0.987,3.106 C0.376,2.547 0.334,1.598 0.894,0.987 C1.178,0.677 1.579,0.5 2,0.5 Z"></path>
                                    <path className="border_3x"
                                        d="M9,1 L2,1 C1.72,1 1.452,1.118 1.263,1.325 C0.89,1.732 0.917,2.365 1.325,2.738 C3.504,4.733 5.046,6.893 5.95,9.218 C7.124,12.233 7.807,15.161 8,18 L8,20 L9,20 L9,1 Z M2,0.667 L9,0.667 L9,20 L7.667,20 L7.667,20 L7.668,18.023 C7.477,15.218 6.802,12.324 5.64,9.338 C4.755,7.064 3.243,4.946 1.1,2.983 C0.557,2.486 0.52,1.643 1.017,1.1 C1.269,0.824 1.626,0.667 2,0.667 Z"></path>
                                </g>
                            </svg>
                        </i>
                        <div className="post">
                            <a className="post-selected-name">{selectedGroup?.name}</a>
                            <div className="media-wrapper">
                                <div
                                    className={`media-container media-count-${gptMedia.length}`}
                                    style={{ display: gptMedia.length === 0 ? 'none' : 'flex' }}
                                >
                                    {gptMedia.map((item, index) => (
                                        <div key={index} className="media-item">
                                            {item.includes('.mp4') || item.includes('.mov') || item.includes('.webm') ? (
                                                <>
                                                    <span className="overlayVideo" onClick={() => openViewer(index)}>
                                                        <Icon28PlayCircleFillGray />
                                                    </span>
                                                    <img
                                                        className="thumbVideo"
                                                        onClick={() => openViewer(index)}
                                                        src={item + '.jpg'}
                                                        width="100%"
                                                        alt={`Video thumbnail ${index}`}
                                                    />
                                                </>
                                            ) : (
                                                <img
                                                    onClick={() => openViewer(index)}
                                                    src={item}
                                                    alt={`Image ${index}`}
                                                    width="100%"
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {isViewerOpen && (
                                <MediaViewer
                                    media={formattedMedia}
                                    initialIndex={initialIndex}
                                    onClose={() => setIsViewerOpen(false)}
                                />
                            )}
                            <div className="gptText" dangerouslySetInnerHTML={{ __html: gptText }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TestGPT;